// extracted by mini-css-extract-plugin
module.exports = {"layout":"base-layout_layout__2O2Bb","content":"base-layout_content__21wlK"};